import { useEffect } from 'react';

import useIsomorphicLayoutEffect from './useIsomorphicLayoutEffect';

const useWindowUpdateHelper = (eventHandler: () => void): void => {
    useIsomorphicLayoutEffect(eventHandler, [eventHandler]);

    useEffect(() => {
        window.addEventListener('resize', eventHandler);
        window.addEventListener('orientationchange', eventHandler);
        return () => {
            window.removeEventListener('resize', eventHandler);
            window.removeEventListener('orientationchange', eventHandler);
        };
    }, [eventHandler]);
};

export default useWindowUpdateHelper;
